/* eslint-disable @typescript-eslint/no-explicit-any */
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Spin, Tabs, TabsProps } from "antd";
import CrewYard from "./CrewYard";
// import Property from "./Property";
import CustomAddress from "./CustomAddress";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../config/hooks";
import { getCrewYardListing } from "../../../CompanySettings/CrewYards/ducks/actions";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  loading: boolean;
  btnApi: () => void;
  title: string;
  paragraph: string;
  scheduleId?: any;
  isStartPoint?: boolean;
  selectedDate?: any;
  setLoading: any;
}

const EditStartFinishPoint = (props: PropsType) => {
  const {
    onClose,
    loading,
    title,
    paragraph,
    scheduleId,
    isStartPoint,
    selectedDate,
    setLoading,
  } = props;
  const dispatch = useAppDispatch();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const [activeTabKey, setActiveTabKey] = useState("1");
  const crewYardListing = useAppSelector(
    (state) => state?.crewYard?.crewYardData
  );

  const onCloseHandler = () => {
    onClose();
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Crew yard",
      children: (
        <CrewYard
          crewYardListing={crewYardListing?.data}
          onCloseHandler={onCloseHandler}
          scheduleId={scheduleId}
          isStartPoint={isStartPoint}
          selectedDate={selectedDate}
          setLoading={setLoading}
        />
      ),
    },
    // {
    //   key: "2",
    //   label: "Property",
    //   children: (
    //     <Property
    //       scheduleId={scheduleId}
    //       onCloseHandler={onCloseHandler}
    //       isStartPoint={isStartPoint}
    //       selectedDate={selectedDate}
    //       setLoading={setLoading}
    //     />
    //   ),
    // },
    {
      key: "3",
      label: "Custom address",
      children: (
        <CustomAddress
          scheduleId={scheduleId}
          onCloseHandler={onCloseHandler}
          isStartPoint={isStartPoint}
          selectedDate={selectedDate}
          setLoading={setLoading}
        />
      ),
    },
  ];

  useEffect(() => {
    if (companyId) {
      const payload = {
        offset: 0,
        limit: 999,
        company_id: companyId,
      };
      dispatch(getCrewYardListing(payload));
    }
  }, [dispatch, companyId]);

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div className="modalWrapper scheduleWrapper">
        <div className="modal_header">
          <div className="title">
            <h3> {title} </h3>
            <p style={{ color: "#151718" }}>{paragraph}</p>
          </div>
        </div>

        <div className="modal_content">
          <Tabs
            items={items}
            className="profileTabs"
            activeKey={activeTabKey}
            onChange={setActiveTabKey}
          />
        </div>
      </div>
    </Spin>
  );
};

export default EditStartFinishPoint;
